export function filter(state) {
  return state.filter;
}

export function date(state) {
  return state.date;
}
